<template>
  <v-row no-gutters>
    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-select v-model="computedValue.province" :items="computedProvinces" :menu-props="{offsetY: true}"
                class="rounded-lg" dense hide-details label="استان" outlined/>
    </v-col>

    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-select v-model="computedValue.city" :disabled="!computedValue.province" :items="computedCities"
                :menu-props="{offsetY: true}" class="rounded-lg" dense hide-details label="شهر" outlined/>
    </v-col>

    <v-col class="pa-2" cols="12" lg="4" md="6">
      <v-text-field v-model="computedValue.postal_code" class="rounded-lg" dense hide-details label="کد پستی" outlined/>
    </v-col>

    <v-col class="pa-2" cols="12">
      <v-textarea v-model="computedValue.address" class="rounded-lg" dense hide-details label="آدرس" outlined
                  rows="3"/>
    </v-col>
  </v-row>
</template>

<script>
import provinces from "@/utilities/provinces";

export default {
  name: "userAddressPicker",

  props: {
    value: Object,
    allowSubmit: Boolean
  },

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    computedProvinces() {
      return Object.keys(provinces)
    },
    computedCities() {
      return provinces[this.computedValue.province]
    },
    canSubmit() {
      return !!this.computedValue.province &&
        !!this.computedValue.city &&
        !!this.computedValue.postal_code &&
        !!this.computedValue.address
    }
  },

  watch: {
    canSubmit(val) {
      this.$emit('update:allowSubmit', val)
    }
  }
}
</script>

<style scoped>

</style>